import React, { Component } from 'react';
import Head from "../../../../components/Head/Head";
import Auxiliary from "../../../../hoc/Auxiliary/Auxiliary";
import { withTranslation } from 'react-i18next';
import OutsourcingPilarBanner from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilarBanner/OutsourcingPilarBanner';
import OutsourcingPilar2 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar2/OutsourcingPilar2';
import OutsourcingPilar3 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar3/OutsourcingPilar3';
import OutsourcingPilar4 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar4/OutsourcingPilar4';
import OutsourcingPilar5 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar5/OutsourcingPilar5';
import OutsourcingPilar6 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar6/OutsourcingPilar6';
import OutsourcingPilar7 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar7/OutsourcingPilar7';
import OutsourcingPilar8 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar8/OutsourcingPilar8';
import OutsourcingPilar9 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar9/OutsourcingPilar9';
import OutsourcingPilar10 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar10/OutsourcingPilar10';
import OutsourcingPilar11 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar11/OutsourcingPilar11';
import OutsourcingPilar12 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar12/OutsourcingPilar12';
import OutsourcingPilar13 from '../../../../components/Services/Pilars/outsourcing/OutsourcingPilar/OutsourcingPilar13/OutsourcingPilar13';
import CallToAction from '../../../../components/UI/CallToAction/CallToAction';

class OutsourcingPilar extends Component {
    render() {
        return (
            <Auxiliary>
                <Head id="outsourcing-pilar" />
                <OutsourcingPilarBanner {...this.props} />
                <OutsourcingPilar2 {...this.props} />
                <OutsourcingPilar3 {...this.props} />
                <OutsourcingPilar4 {...this.props} />
                <OutsourcingPilar5 {...this.props} />
                <OutsourcingPilar6 {...this.props} />
                <OutsourcingPilar7 {...this.props} />
                <OutsourcingPilar8 {...this.props} />
                <OutsourcingPilar9 {...this.props} />
                <OutsourcingPilar10 {...this.props} />
                <OutsourcingPilar11 {...this.props} />
                <OutsourcingPilar12 {...this.props} />
                <OutsourcingPilar13 {...this.props} />
                <div className='custom-end'></div>
            </Auxiliary>
        );
    }
}
export default withTranslation()(OutsourcingPilar);